import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-nonmember',
  templateUrl: './landing-nonmember.component.html',
  styleUrls: ['./landing-nonmember.component.scss']
})
export class LandingNonmemberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
